import de_inferno from '../../content/maps/de_inferno.jpg';
import de_mirage from '../../content/maps/de_mirage.jpg';
import de_nuke from '../../content/maps/de_nuke.jpg';
import de_overpass from '../../content/maps/de_overpass.jpg';
import de_ancient from '../../content/maps/de_ancient.jpg';
import de_vertigo from '../../content/maps/de_vertigo.jpg';
import de_anubis from '../../content/maps/de_anubis.jpg';
import de_dust2 from '../../content/maps/de_dust2.jpg';
import de_train from '../../content/maps/de_train.jpg';
import de_cache from '../../content/maps/de_cache.jpg';

/** Map photo thumbnails (same JPGs used by Veto / HomePageV2 / clip cards). */
export const mapPhotoMappings: Record<string, string> = {
    de_inferno, de_mirage, de_nuke, de_overpass, de_ancient,
    de_vertigo, de_anubis, de_dust2, de_train, de_cache,
};
